/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';
import {Forecast, ForecastList} from 'features/forecast/types';

interface Options {
  original: CommonChartData[];
  primaryForecast: ForecastList;
  secondaryForecast?: ForecastList | null;
}

const injectForecastToChartData = ({
  original,
  primaryForecast,
  secondaryForecast,
}: Options): CommonChartData[] => {
  return original.map(data => {
    const calculatedPrimary: Forecast = primaryForecast[data.name];
    const calculatedSecondary: Forecast | null = secondaryForecast
      ? secondaryForecast[data.name]
      : null;

    if (!calculatedPrimary && !calculatedSecondary) {
      return data;
    }

    const newData: CommonChartData = {
      ...data,
      ...(calculatedPrimary || {}),
    };

    if (calculatedSecondary) {
      newData.averageSecondary = calculatedSecondary.average;
      newData.rangeSecondary = calculatedSecondary.range;
    }

    return newData;
  });
};

export {injectForecastToChartData};
